<template>
  <VaCard class="h-full">
    <VaCardContent>
      <section>
        <header class="flex items-center">
          <h3 class="mb-3 font-bold text-lg grow" style="text-transform: none">{{ title }}</h3>
          <div
            class="p-1 rounded"
            :style="{
              backgroundColor: iconBackground,
              color: iconColor,
            }"
          >
            <slot name="icon"></slot>
          </div>
        </header>
        <div>
          <div class="text-lg font-semibold grow">{{ value }}</div>
          <p v-if="!titleOnly" class="text-xs text-secondary">
            <span :class="changeClass">
              <template v-if="up">↑</template>
              <template v-else>↓</template>
              {{ changeText }}
            </span>
            desde el mes pasado
          </p>
        </div>
      </section>
    </VaCardContent>
  </VaCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { VaCard } from 'vuestic-ui'

const props = defineProps<{
  title: string
  value: string | number
  changeText: string
  up: boolean
  iconBackground: string
  iconColor: string
  titleOnly?: boolean
}>()

const changeClass = computed(() => ({
  'text-success': props.up,
  'text-red-600': !props.up,
}))
</script>

<style scoped>
.scrollable-data-list {
  max-height: 200px;
  overflow-y: auto;
}
</style>
